import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyBrokerAccountMatchingDashboardRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerAccountMatching/Dashboard')));
const LazyBrokerAccountMatchingNextRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerAccountMatching/Next')));
const LazyBrokerAccountMatchingShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerAccountMatching/Show')));

export const BrokerAccountMatchingDashboard = (props: ComponentProps) =>
  <LazyBrokerAccountMatchingDashboardRoute {...props} />;
export const BrokerAccountMatchingNext = (props: ComponentProps) =>
  <LazyBrokerAccountMatchingNextRoute {...props} />;
export const BrokerAccountMatchingShow = (props: ComponentProps) =>
  <LazyBrokerAccountMatchingShowRoute {...props} />;
